<template>
  <v-layout wrap style="background-color: rgba(0, 0, 0, 0.1);margin-top:20px;border-radius: 10px; padding: 0 20px;">
    <v-flex xs12>
      <v-checkbox
        :value="withDescription"
        :label="$t('brochure.description')"
        @change="handleChangeDescription(!withDescription)"
      />
    </v-flex>
    <v-layout wrap v-if="withDescription" align-center>
      <translate
        v-model="value.Description"
        :languages="languages"
        :label="$t('brochure.description')"
        @input="handleChangeIsModified"
        style="padding: 0 10px 0 10px;"
      />
      <translate
        v-model="value.Note"
        :languages="languages"
        :label="$t('brochure.note')"
        @input="handleChangeIsModified"
        style="padding: 0 10px 0 10px;"
      />
    </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
const descriptionDefault = {
  Description: { es: null },
  Note: { es: null },
}

  import { mapState } from 'vuex'
  import Translate from '@/components/Translate'

  export default {
    components: {
      Translate,
    },
    props: {
      value: {
        type: Object,
        default: null
      }
    },
    data: () => ({
      withDescription: false,
    }),
    computed: {
      ...mapState('app',['collapseContent', 'locale']),
      languages () {
        return this.$store.state.app.Languages
      },
    },
    watch: {
      value (v) {
        if (v !== null && !this.withDescription) {
          this.handleChangeDescription(true)
        } else if (v === null && this.withDescription) {
          this.handleChangeDescription(false)
        }
      },
    },
    mounted () {

    },
    methods: {
      handleChangeDescription (v) {
        if (v) {
          this.value = JSON.parse(JSON.stringify(descriptionDefault))
        } else {
          this.value = null
        }
        this.withDescription = v
        this.handleChangeIsModified()
      },
      handleChangeIsModified () {
      },
    },
  }
</script>
 
